import { DocumentType, Gender } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const selectDocumentTypeArray = Object.values(DocumentType).map((type) => ({
  value: type,
  display: <Text tId={type} />,
}));

export const selectGenderTypeArray = Object.keys(Gender).map((type) => ({
  value: type,
  display: <Text tId={Gender[type]} />,
}));
